import React, { useState, useEffect } from 'react'
import { Form, FormGroup, Input, Button } from 'reactstrap'
import { updateData, addData } from '../../lib/studentpersonalquestion'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

const PersonalQuestionEdit = ({ value, setValue, id, studentId, questionId }) => {
	const [answer, setAnswer] = useState(value)
	const [loading, setLoading] = useState(false)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)

		try {
			// First, update the database
			if (id === 0) {
				await addData({
					studentId: studentId,
					questionId: questionId,
					isAnswer: true,
					studentAnswer: answer
				})
			} else {
				await updateData({
					id: id,
					studentAnswer: answer
				})
			}

			// Then trigger parent re-fetch (after database update completes)
			setValue()

			showToastMessage('Update successful!')
		} catch (error) {
			console.error('Error updating answer:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		setAnswer(value)
	}, [value])

	return (
		<Form onSubmit={handleSubmit}>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<FormGroup>
				<Input
					type="textarea"
					className="form-control"
					value={answer}
					onChange={(e) => setAnswer(e.target.value)}
					rows="4"
					placeholder="Enter your answer here..."
				/>
			</FormGroup>
			<div className="d-flex justify-content-between">
				<Button type="submit" color="primary" disabled={loading}>
					<i className="fa fa-save me-2"></i>
					{loading ? 'Updating...' : 'Update Answer'}
				</Button>
			</div>
		</Form>
	)
}

export { PersonalQuestionEdit }
